import { render, staticRenderFns } from "./MaterialList.vue?vue&type=template&id=49021c47&scoped=true"
import script from "./MaterialList.vue?vue&type=script&lang=js"
export * from "./MaterialList.vue?vue&type=script&lang=js"
import style0 from "./MaterialList.vue?vue&type=style&index=0&id=49021c47&prod&scoped=true&lang=css"
import style1 from "./MaterialList.vue?vue&type=style&index=1&id=49021c47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49021c47",
  null
  
)

export default component.exports